var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkOutlineTicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m411.94 26.672h376.18c69.188 0 132.14 28.312 177.71 73.875s73.875 108.52 73.875 177.71v769.87c0 22.406-5.5781 43.453-16.078 61.875-10.453 18.375-25.688 33.938-45.094 45.469-19.266 11.438-40.219 17.391-61.406 17.812-21.047 0.375-42.141-4.7344-61.922-15.516l-255.19-138.74-255.19 138.74c-19.781 10.781-40.875 15.891-61.922 15.516-21.188-0.375-42.141-6.375-61.406-17.812-19.359-11.531-34.594-27.094-45.094-45.469-10.453-18.375-16.078-39.422-16.078-61.875v-769.87c0-69.188 28.312-132.14 73.875-177.71 45.609-45.609 108.52-73.875 177.71-73.875zm-3.6562 515.48c-9.5625-8.3906-10.453-22.875-2.0625-32.438s22.922-10.453 32.438-2.0625l136.18 119.77 221.21-233.34c8.7656-9.1875 23.25-9.5625 32.438-0.79688s9.5625 23.25 0.79688 32.438l-235.78 248.76c-8.3906 9.5625-22.922 10.453-32.438 2.0625z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutlineTicked);
export default __webpack_public_path__ + "static/media/bookmark-outline-ticked.108fb3fb35ecdd137a202c39fbe4123a.svg";
export { ForwardRef as ReactComponent };